import React from 'react';
import type { EmailExclusionJob } from '../types';
import ReactTable from 'react-table';
import { Tag } from 'antd';
import { getCampaignFolderOrdering } from '../utils';

type Props = {
  job: EmailExclusionJob,
};

function RenderTags({ tags }: { tags: string[] }) {
  if (!tags || tags.length === 0) return 'N/A';
  return (
    <div className="flex flex-wrap">
      {tags.map((v, i) => (
        <Tag className="mr-2 mb-2" key={i}>
          {v}
        </Tag>
      ))}
    </div>
  );
}

const columnDefs = [
  {
    Header: 'Folder',
    id: 'folder',
    accessor: row => <b>{row.folder}</b>,
  },
  {
    Header: 'Email Domains',
    id: 'emailDomains',
    accessor: row => <RenderTags tags={row.domains} />,
  },
  {
    Header: 'Providers',
    id: 'providers',
    accessor: row => <RenderTags tags={row.providers} />,
  },
  {
    Header: 'Ranks',
    id: 'ranks',
    accessor: row => <RenderTags tags={row.ranks} />,
  },
  {
    Header: 'Company Name Regexp',
    id: 'companyNameRegexp',
    accessor: row =>
      row.companyNameRegexp ? (
        <pre style={{ marginBottom: 0 }}>/{row.companyNameRegexp}/</pre>
      ) : (
        'N/A'
      ),
  },
];

export default function PostExclusionCriteriaTable(props: Props) {
  const ordering = getCampaignFolderOrdering(props.job);
  const data = Object.entries(props.job.postExclusionCriteria).map(
    ([key, value]) => ({ folder: key, ...value }),
  );
  data.sort((a, b) => {
    const aIndex = ordering.indexOf(a.folder);
    const bIndex = ordering.indexOf(b.folder);
    if (aIndex === -1 && bIndex === -1) return 0;
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });
  return (
    <ReactTable
      className="-striped -highlight"
      columns={columnDefs}
      data={data}
      defaultPageSize={5}
      firstText={<i className="material-icons">first_page</i>}
      indexKey="id"
      lastText={<i className="material-icons">last_page</i>}
      minRows={0}
      nextText={<i className="material-icons">chevron_right</i>}
      previousText={<i className="material-icons">chevron_left</i>}
      sortable={false}
    />
  );
}
